<script>

    import Select from './select.svelte'

    export let ownerId = null
    export let label = null

</script>

<Select
    on:change
    label={ label }
    bind:value={ ownerId }
    options={[
        {value: '60edc374e9091e00151699c0', text: 'Fernando Islas'},
        {value: '60edc320e9091e001516972f', text: 'Octavio Amaro'},
    ]}
/>